import moment from 'moment';
import React from 'react';

const VehicleReg = (props: any) => props.children;

const CarReg = (props: any) => {
  const infoData = props.infoData;
  const vehicleData = props.vehicleData;
  const selectData = props?.selectData;

  return (
    <div className="vehicle-reg-container vehicle-reg-container__car">
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">牌照號碼</div>
        <div className="vehicle-reg__text">
          <span className="license-number-container">
            {infoData.LICENSE_PLATE_NUMBER_FRONT +
            '-' +
            infoData.LICENSE_PLATE_NUMBER_BACK}
          </span>
          <span>{infoData.VEHICLE_TYPE_NAME}</span>
        </div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">廠牌</div>
        <div className="vehicle-reg__text">{vehicleData.VEHICAL_MAKER || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">型式</div>
        <div className="vehicle-reg__text">{vehicleData.VEHICAL_MODEL_NAME || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">{vehicleData.ENGINE_DISPLACEMENT_UNIT === 'CC' ? '排氣量' : '馬力'}</div>
        <div className="vehicle-reg__text">
          {vehicleData.ENGINE_DISPLACEMENT ? (vehicleData.ENGINE_DISPLACEMENT + ' ' + (vehicleData.ENGINE_DISPLACEMENT_UNIT === 'CC' ? 'c.c數' : 'hp數')) : '--'}
        </div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">引擎號碼</div>
        <div className="vehicle-reg__text">{selectData?.ENGINE_NUMBER || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">車身號碼</div>
        <div className="vehicle-reg__text">{selectData?.VEHICAL_BODY_NUMBER || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">載運人數</div>
        <div className="vehicle-reg__text">{vehicleData.LIMIT || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">製造年月</div>
        <div className="vehicle-reg__text">{vehicleData.MANUFACTUR_YEAR_MONTH ? moment(vehicleData.MANUFACTUR_YEAR_MONTH).format('YYYY.MM') : '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">原發照日</div>
        <div className="vehicle-reg__text">{vehicleData.ORIGINAL_DATE_YEAR + '.' + vehicleData.ORIGINAL_DATE_MONTH + '.' + vehicleData.ORIGINAL_DATE_DATE}</div>
      </div>
    </div>
  );
};

const MotoReg = (props: any) => {
  const infoData = props.infoData;
  const vehicleData = props.vehicleData;
  const selectData = props?.selectData;

  return (
    <div className="vehicle-reg-container vehicle-reg-container__moto">
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">牌照號碼</div>
        <div className="vehicle-reg__text">
          <span className="license-number-container">
            {infoData.LICENSE_PLATE_NUMBER_FRONT +
            '-' +
            infoData.LICENSE_PLATE_NUMBER_BACK}
          </span>
          <span>{infoData.VEHICLE_TYPE_NAME}</span>
        </div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">廠牌</div>
        <div className="vehicle-reg__text">{vehicleData.VEHICAL_MAKER || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">型式</div>
        <div className="vehicle-reg__text">{vehicleData.VEHICAL_MODEL_NAME || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">{vehicleData.ENGINE_DISPLACEMENT_UNIT === 'CC' ? '排氣量' : '馬力'}</div>
        <div className="vehicle-reg__text">
          {vehicleData.ENGINE_DISPLACEMENT ? (vehicleData.ENGINE_DISPLACEMENT + ' ' + (vehicleData.ENGINE_DISPLACEMENT_UNIT === 'CC' ? 'c.c數' : 'hp數')) : '--'}
        </div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">引擎號碼</div>
        <div className="vehicle-reg__text">{selectData?.ENGINE_NUMBER || '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">製造年月</div>
        <div className="vehicle-reg__text">{vehicleData.MANUFACTUR_YEAR_MONTH ? moment(vehicleData.MANUFACTUR_YEAR_MONTH).format('YYYY.MM') : '--'}</div>
      </div>
      <div className="vehicle-reg__row">
        <div className="vehicle-reg__title">原發照日</div>
        <div className="vehicle-reg__text">{vehicleData.ORIGINAL_DATE_YEAR + '.' + vehicleData.ORIGINAL_DATE_MONTH + '.' + vehicleData.ORIGINAL_DATE_DATE}</div>
      </div>
    </div>
  );
};

VehicleReg.CarReg = CarReg;
VehicleReg.MotoReg = MotoReg;

export default VehicleReg;
